<template>
    <div class="vote">
        <el-table :data="vote" border v-loading="loading" :height="height" class="tableLimit votebox">
            <el-table-column prop="vote_name" label="投票名称"></el-table-column>
            <el-table-column prop="create_time" label="开始时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="deadline" label="截止时间" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.voteEnd==1" style="color:red">已过期</span>
                    <span v-else>{{scope.row.deadline}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="record_count" label="投票人数"></el-table-column>
            <el-table-column label="查看投票用户" align="center">
                <template slot-scope="scope">
                    <el-link type="primary" @click="voteuser(scope.row)">查看用户</el-link>
                </template>
            </el-table-column>
        </el-table>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                vote: [],
                textId: '',
                loading: false,
                height: null,

            }
        },
        mounted() {
            this.getHeight()

        },
        methods: {
            getHeight() {
                let that = this

                that.height = window.innerHeight - 175 + 'px'
                window.onresize = () => {

                    that.height = window.innerHeight - 175 + 'px'
                }
            },
            getvotelist(id) {
                axios
                    .post("/admin/VoteHistoryRecord/getVote", {
                        activity_id: id,
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {

                            this.vote = response.data.data
                        } else {
                            that.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            voteuser(data) {
                sessionStorage.setItem('vote_id',data.id)
                this.$nextTick(() => {
                    this.$parent.$parent.uservotelist = true
                    this.$nextTick(()=>{
                       this.$parent.$parent.$refs.uservotelist.getvoteuserlist(data.id) 
                       this.$parent.$parent.$refs.uservotelist.vote_id = data.id
                    })
                    
                    
                })
                

            },

        }
    }
</script>

<style lang="scss" scoped>

</style>